import { inject, injectable } from 'tsyringe';
import { type ISupportUserTokenRepository } from 'application/repositorySchemas/ISupportUserTokenRepository';
import { type ITransferApplyRepository } from 'application/repositorySchemas/ITransferApplyRepository';
import { type ITransferApplyClient } from 'interfaceAdapter/gatewaySchemas/ITransferApplyClient';

@injectable()
export class TransferApplyRepository implements ITransferApplyRepository {
    constructor(
        @inject('ISupportUserTokenRepository')
        public readonly supportUserToken: ISupportUserTokenRepository,
        @inject('ITransferApplyClient')
        public readonly transferApplyClient: ITransferApplyClient,
    ) {}

    public async apply(transferId: number, accountNumber: string): Promise<void> {
        const { message } = await this.transferApplyClient.post({
            token: this.supportUserToken.get() || '',
            transfer_id: transferId,
            account_number: accountNumber,
        });

        if (message) {
            throw new Error(message);
        }
    }
}
